import Image from 'next/image';
import Link from 'next/link';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import DownloadIcon from '@/shared/components/icons/download-icon';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const ForCompaniesMain = () => {
  return <Article tag="main">
      <div className="grid grid-cols-1 items-center gap-x-5 sm:grid-cols-[1fr_minmax(280px,_30%)] sm:gap-x-10 md:grid-cols-2">
        <div className="mx-auto sm:mx-0">
          <div className="mb-10 sm:mb-8">
            <TextGradient text="Корпоративный английский" tag="h1" className="mb-6 text-center text-5xl sm:mb-4 sm:max-w-lg sm:text-left" />

            <p className="mx-auto max-w-xs text-sm xss:max-w-sm xss:text-base sm:mx-0 sm:text-sm md:max-w-xl md:text-base">
              Ваши сотрудники работают с&nbsp;международными клиентами, ведут переговоры или готовятся к&nbsp;новым
              проектам за&nbsp;рубежом?
              <br />
              Уверенное владение английским&nbsp;&mdash; ключ к&nbsp;успеху на&nbsp;глобальном рынке.
              <br />
              Мы&nbsp;разработаем индивидуальную программу обучения для ваших сотрудников, чтобы
              вы&nbsp;взаимодействовали с&nbsp;иностранными клиентами без барьеров!
            </p>
          </div>

          <div className="flex flex-col-reverse items-center gap-y-2 sm:items-start lg:flex-row lg:items-center lg:space-x-4">
            <Link href={process.env.NEXT_PUBLIC_TG_SUPPORT_URL ?? ''} target="_blank" aria-label="Связаться с нами">
              <Button variant="cta" className="px-6" aria-label="Связаться с нами">
                Связаться с нами
              </Button>
            </Link>

            <Link href="/files/enlerno-business-proposal_v2.pdf" rel="noopener noreferrer" target="_blank" download={`${APP_TITLE} - Коммерческое предложение`}>
              <Button className="space-x-2" type="button" aria-label="Скачать коммерческое предложение" aria-describedby="download-business-proposal">
                <span>
                  <span className="hidden sm:inline">Скачать</span>&nbsp;
                  <span className="capitalize sm:lowercase">коммерческое</span>&nbsp;предложение
                </span>

                <DownloadIcon className="h-5 w-5 text-brand-accent-normal dark:text-brand-accent-light" aria-hidden />
              </Button>
            </Link>
          </div>
        </div>

        <div className="relative hidden items-center justify-end sm:flex 2xl:justify-center">
          <figure className="relative mx-auto block">
            <Image className="rounded-md ring ring-brand-accent-light ring-transparent ring-offset-1" width={400} height={400} priority src="/images/for-companies/main.webp" alt={`Анна Сладких – основатель онлайн школы английского ${APP_TITLE}`} />

            <figcaption className="mt-2 block text-right text-xs text-muted-foreground">
              Анна Сладких – основатель школы
            </figcaption>
          </figure>

          <GradientBg className="z-0 hidden sm:block" type="circle" origin="center" size={260} />
        </div>
      </div>
    </Article>;
};